import { render, staticRenderFns } from "./ProductBuilder.vue?vue&type=template&id=2295e409"
import script from "./ProductBuilder.vue?vue&type=script&lang=js"
export * from "./ProductBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports